
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("budget/round_progress",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <animate attributeName=\"stroke\" from=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\" to=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"endColor") : depth0), depth0))
    + "\" dur=\"1s\" fill=\"freeze\"/><animate attributeName=\"fill\" from=\"#F5F5F5\" to=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"endColor") : depth0), depth0))
    + "33\" dur=\"1s\" fill=\"freeze\"/> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<svg width=\"36\" height=\"36\" xmlns=\"http://www.w3.org/2000/svg\" data-cache-killer=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"cacheKiller") : depth0), depth0))
    + "\"><path stroke-width=\"1\" fill=\"#EEEEEE\" stroke=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\" d=\"M17.99 2.08 A 15.92 15.92 1 1 0 18 2.08\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"endColor") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":205},"end":{"line":1,"column":416}}})) != null ? stack1 : "")
    + " </path><path stroke-width=\"1.5\" fill=\"transparent\" stroke=\"#CCC\" d=\"M17.99 2.08 A 15.92 15.92 1 1 0 18 2.08\" stroke-dasharray=\"100\"><animate attributeName=\"stroke-dashoffset\" from=\"0\" to=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"percent") : depth0), depth0))
    + "\" dur=\"1s\" fill=\"freeze\"/></path></svg>";
},"useData":true});
export default TPL;